import { useState, useEffect, useCallback } from "react";
import "../Surveys.css";
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";
import { parse } from "papaparse";
import SurveyNational from "../../reusable/SurveyNational/SurveyNational";
import TEXT from "../../../utils/text/surveys_national.json";

async function getDataFromCsv(url) {
  const data = parse(await fetchCsv(url), { header: true });
  return data.data;
}

async function fetchCsv(url) {
  const responseFetch = await fetch(url);
  const readerResponse = responseFetch.body.getReader();
  const resultResponse = await readerResponse.read();
  const decoderResponse = new TextDecoder("utf-8");
  const csvResult = decoderResponse.decode(resultResponse.value);
  return csvResult;
}

export default function Argentina({ survey }) {
  const { language } = useCurrentLanguage();
  const [data, setData] = useState([]);
  const [questions, setQuestions] = useState([]);

  // 2. Wrapped in useCallback to stabilize the function reference
  const handleGetDataFromCsv = useCallback(async () => {
    const csv1_arg = await getDataFromCsv(
      `/surveysNational/${language === "en" ? "/en/" : ""}argentina_q1.csv`
    );
    const csv2_arg = await getDataFromCsv(
      `/surveysNational/${language === "en" ? "/en/" : ""}argentina_q2.csv`
    );

    const csv3 = await getDataFromCsv(
      `/surveysNational/${language === "en" ? "/en/" : ""}argentina_q3.csv`
    );

    const csv4 = await getDataFromCsv(
      `/surveysNational/${language === "en" ? "/en/" : ""}argentina_q4.csv`
    );

    const csv5 = await getDataFromCsv(
      `/surveysNational/${language === "en" ? "/en/" : ""}argentina_q5.csv`
    );

    const y_data1_arg = Object.keys(csv1_arg[0]).filter(
      (e) => e !== "Afirmacion"
    );
    const x_data1_arg = csv1_arg.map((e) => e["Afirmacion"]);
    const series1_arg = y_data1_arg.map((e, i) => {
      return x_data1_arg.map((el) =>
        Number(csv1_arg.find((e) => e["Afirmacion"] === el)[y_data1_arg[i]])
      );
    });
    const data1_arg = [y_data1_arg, x_data1_arg, series1_arg];

    const y_data2_arg = Object.keys(csv2_arg[0]).filter(
      (e) => e !== "Afirmacion"
    );
    const x_data2_arg = csv2_arg.map((e) => e["Afirmacion"]);
    const series2_arg = y_data2_arg.map((e, i) => {
      return x_data2_arg.map((el) =>
        Number(csv2_arg.find((e) => e["Afirmacion"] === el)[y_data2_arg[i]])
      );
    });
    const data2_arg = [y_data2_arg, x_data2_arg, series2_arg];

    // new ones latam
    const y_data3 = Object.keys(csv3[0]).filter((e) => e !== "Afirmacion");
    const x_data3 = csv3.map((e) => e["Afirmacion"]);
    const series3 = y_data3.map((e, i) => {
      return x_data3.map((el) =>
        Number(csv3.find((e) => e["Afirmacion"] === el)[y_data3[i]])
      );
    });
    const data3 = [y_data3, x_data3, series3];

    const y_data4 = Object.keys(csv4[0]).filter((e) => e !== "Afirmacion");
    const x_data4 = csv4.map((e) => e["Afirmacion"]);
    const series4 = y_data4.map((e, i) => {
      return x_data4.map((el) =>
        Number(csv4.find((e) => e["Afirmacion"] === el)[y_data4[i]])
      );
    });
    const data4 = [y_data4, x_data4, series4];

    const y_data5 = Object.keys(csv5[0]).filter((e) => e !== "Afirmacion");
    const x_data5 = csv5.map((e) => e["Afirmacion"]);
    const series5 = y_data5.map((e, i) => {
      return x_data5.map((el) =>
        Number(csv5.find((e) => e["Afirmacion"] === el)[y_data5[i]])
      );
    });
    const data5 = [y_data5, x_data5, series5];

    let tempData = [
      {
        id: "q1",
        question: TEXT["ARG"]["q1"]["question"][language],
        source: TEXT["ARG"]["q1"]["source"][language],
        description: TEXT["ARG"]["q1"]["description"][language],
        narrative: TEXT["ARG"]["q1"]["narrative"][language],
        data: data1_arg,
        graphType: "s_h_bar",
        hasOptions: false,
        isLarge: true,
        survey: TEXT["ARG"]["q1"]["survey"][language],
        link: TEXT["ARG"]["q1"]["link"],
      },
      {
        id: "q2",
        question: TEXT["ARG"]["q2"]["question"][language],
        source: TEXT["ARG"]["q2"]["source"][language],
        description: TEXT["ARG"]["q2"]["description"][language],
        narrative: TEXT["ARG"]["q2"]["narrative"][language],
        data: data2_arg,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["ARG"]["q2"]["survey"][language],
        link: TEXT["ARG"]["q2"]["link"],
      },
      {
        id: "q3",
        question: TEXT["ARG"]["q3"]["question"][language],
        source: TEXT["ARG"]["q3"]["source"][language],
        description: TEXT["ARG"]["q3"]["description"][language],

        data: data3,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["ARG"]["q3"]["survey"][language],
        link: TEXT["ARG"]["q3"]["link"],
      },
      {
        id: "q4",
        question: TEXT["ARG"]["q4"]["question"][language],
        source: TEXT["ARG"]["q4"]["source"][language],
        description: TEXT["ARG"]["q4"]["description"][language],

        data: data4,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["ARG"]["q4"]["survey"][language],
        link: TEXT["ARG"]["q4"]["link"],
      },
      {
        id: "q5",
        question: TEXT["ARG"]["q5"]["question"][language],
        source: TEXT["ARG"]["q5"]["source"][language],
        description: TEXT["ARG"]["q5"]["description"][language],

        data: data5,
        graphType: "g_h_bar",
        hasOptions: false,
        survey: TEXT["ARG"]["q5"]["survey"][language],
        link: TEXT["ARG"]["q5"]["link"],
      },
    ];

    let tempQ_arg = [];
    tempData.forEach((e) => {
      if (e.survey === survey)
        tempQ_arg.push({ code: e.id, label: e.question });
    });
    setData(tempData.filter((el) => el.survey === survey));
    setQuestions(tempQ_arg);
  }, [language, survey]);

  useEffect(() => {
    if (survey !== "") handleGetDataFromCsv();
  }, [survey, handleGetDataFromCsv]);

  return (
    <div>
      <SurveyNational data={data} questions={questions} title={survey} />
    </div>
  );
}
